export default "__VITE_ASSET__Bx_23R0___"